module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsChristmas.ac2659d.webp";